import { useMutation, useQueryClient } from '@tanstack/react-query';
import { gqlFetcher, type MutationOptions } from '../fetcher';
import { UpdateParticipantBehaviour } from '../mutations/updateParticipantBehaviour.mutation';
import type {
  UpdateParticipantBehaviourMutation,
  UpdateParticipantBehaviourMutationVariables,
} from '../types';

export const useUpdateParticipantBehaviourMutation = (
  options?: MutationOptions<
    UpdateParticipantBehaviourMutation,
    UpdateParticipantBehaviourMutationVariables
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(UpdateParticipantBehaviour), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('participant'),
      });
    },
  });
};
